"use client";

import { AppState } from "@/store/store";
import { useEffect } from "react";
import { useSelector } from "react-redux";

function isBootstrapModalOpen(): boolean {
  if (typeof document === "undefined" || !document.body) {
    return false;
  }
  return document.body.classList.contains("modal-open");
}

function releaseOverlayScrollLock(): void {
  if (!isBootstrapModalOpen()) {
    document.body.style.overflow = "";
  }
  document.documentElement.style.touchAction = "auto";
}

/**
 * This component locks the page scroll when the overlay is darkened.
 * It reads from the Redux overlayDarkeningSlice to determine when to lock/unlock scroll.
 * This component renders nothing - it just manages the body scroll state.
 */
export default function BodyScrollLock() {
  const isDarkened = useSelector((state: AppState) => state.overlayDarkeningSlice.isDarkened);

  useEffect(() => {
    if (typeof window === "undefined" || !document?.body) {
      return;
    }

    if (isDarkened) {
      document.body.style.overflow = "hidden";

      // iOS Safari specific fix
      // Disable panning (scrolling) but allow pinch-zoom gestures
      // https://stackoverflow.com/a/63129727
      document.documentElement.style.touchAction = "pinch-zoom";
    } else {
      releaseOverlayScrollLock();
    }

    return () => {
      if (typeof window !== "undefined" && document.body) {
        releaseOverlayScrollLock();
      }
    };
  }, [isDarkened]);

  return null;
}
